import { faCaretDown, faCaretRight, faChevronLeft, faCommentAlt, faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button, ButtonGroup, Col, Form, Row, Table } from 'react-bootstrap';
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router";
import { SemanticVersion } from "./Utilities/SemanticVersion";
import MDEditor from '@uiw/react-md-editor';

const placeHolderImg = (e) =>{
    e.target.src = "/placeHolder.png"
}

const ExampleMapCard = (props) => {
    const {map} = props;
    return (                    
        <div className="mr-2">
            <img 
                variant="top" 
                onError={placeHolderImg}  
                src={map.thumbnail ?? "/placeHolder.png"} 
                style={{ width: "100px", height: "100px" }}
                alt={map.name}
            />
            <p>{map.name ?? "N/A"}</p>
        </div>
    );
}

const CollapseParagraph = (props) => {
    const {value, collapse, version} = props;
    const [isCollapse, setIsCollapse] = useState(collapse);

    const handleClick = () => {
        setIsCollapse(!isCollapse);
    }

    return (
        <div>
            {isCollapse ? 
                value ?
                    value.length > 50 ?
                    <span onClick={handleClick}>
                        <FontAwesomeIcon style={{marginRight: "4px"}} icon={faCaretRight}/>
                        {value.slice(0, 50)+"..."}
                    </span>
                    : value
                : `Version ${version}`
            : <span onClick={handleClick}><FontAwesomeIcon icon={faCaretDown}/> {value}</span>}
        </div>
    );
}

function ModuleDetail(props){
    const { id } = props
    const { allModules } = props;
    const [comment, setComment] = useState("");

    const allVersions = allModules?.filter(module => module.id === id && module.visible === true)
                        .sort((a, b) => 
                                -SemanticVersion.compare(
                                    new SemanticVersion(a.version), 
                                    new SemanticVersion(b.version)))
    const latestVersion = allVersions ? allVersions[0] : null
    const firstVersion = allVersions ? allVersions[allVersions.length - 1] : null
    const history = useHistory()

    const versionsTable = [];
    if (allVersions){
        allVersions.forEach(v =>{
            versionsTable.push(
            <tr>
                <td>{v.version}</td>
                <td><CollapseParagraph value={v.release_note} version={v.version} collapse={true}/></td>
                <td>{v.updatedAt ?? 'N/A'}</td>
            </tr>)
        })
    }

    const handleCommentChange = (e) => {
        setComment(e.target.value);
    }

    const handleCommentSubmit = () => {
        // TODO
    }

    const clearComment = () => {
        setComment("");
    }
        
    const detailHeader =(
        <div id="detailHeader" role="navigation" style={{width: "100%"}}>
            <span onClick={() => {history.push('/')}}>
                <FontAwesomeIcon icon={faChevronLeft} />&nbsp; Back to all modules
            </span>
            <a href={`/module/${id}`}>
                <span style={{fontWeight: 700}}>&nbsp;&nbsp;|&nbsp;&nbsp;{id} </span>
            </a>
        </div>
    );

    const thumbnailCol = (
        <Col className="col-xs-12 col-md-6 col-xl-3">
            <img 
                src={latestVersion?.thumbnail ?? "/placeHolder.png"} 
                style={{ width: "256px", height: "256px" }} 
                onError={placeHolderImg} 
                loading="lazy" 
                className="gameImage" 
                alt={id}
            />
        </Col>
    );

    const titleRow = (
        <Row>
            <Col>
                <h1>{latestVersion ? latestVersion.id : "Loading..."}</h1>
            </Col>
        </Row>
    );

    const statisticsRow = (
        <Row>
            <Col >
                <p> Newest Version: {latestVersion?.version}</p>
                <p>by Unknown</p>
                {/* <p>by {latestVersion?.authors ?? 'Unknown'}</p> */}
            </Col>
            <Col>
                <span className='d-flex justify-content-end'>
                    <span className='mr-4'><FontAwesomeIcon style={{color: 'red'}} icon={faThumbsUp} /> {latestVersion?.upvotesCount ?? 0} </span>
                    <span><FontAwesomeIcon style={{color: 'blue'}} icon={faCommentAlt} /> {latestVersion?.commentsCount ?? 0}</span>
                </span>
                <span className='d-flex justify-content-end'>Created at: {firstVersion?.updatedAt ?? 'N/A'}</span>
                <span className='d-flex justify-content-end'>Lastest updated at: {latestVersion?.updatedAt ?? 'N/A'}</span>
            </Col>
        </Row>
    );

    const descriptionRow = (
        <Row>
            <Col>
                <p><strong>Description</strong></p>
                <MDEditor.Markdown source={latestVersion?.description ?? 'Author has not submitted description yet.'} />
            </Col>
        </Row>
    );

    const versionsRow = (
        <Row className='mt-4'>
            <Col>
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th style={{width:"20%"}}>Version</th>
                            <th style={{width:"60%"}}>Release Note</th>
                            <th style={{width:"20%"}}>Updated At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {versionsTable}
                    </tbody>
                </Table>
            </Col>
        </Row>
    );

    const exampleMapsRow = (
        <Row className='mt-4'>
            <Col>
                <p><strong>Example Maps</strong></p>
                <div className="d-flex flex-row flex-nowrap overflow-auto">
                    {latestVersion?.exampleMaps ? 
                        latestVersion?.exampleMaps.map(map => {
                            return (
                                <ExampleMapCard map={map}/>
                            )
                        }) : "No example maps for now."}
                </div>
            </Col>
        </Row>
    );

    const commentsRow = (
        <Row className='mt-4'>
            <Col>
                <p><strong>Leave a review</strong></p>
                <ButtonGroup aria-label="Basic example">
                    <Button variant="outline-danger" style={{width:"200px"}}>
                        <FontAwesomeIcon icon={faThumbsUp}/> Recommend
                    </Button>
                    <Button variant="outline-danger" style={{width:"200px"}}>
                        <FontAwesomeIcon icon={faThumbsDown} /> Don't recommend
                    </Button>
                </ButtonGroup>
                <Form.Group className="mt-4">
                    <Form.Control onChange={handleCommentChange} value={comment} as="textarea" rows={6} placeholder="Share your thoughts on the module!" />
                </Form.Group>
                <div className="d-flex justify-content-between">
                    <Button size="sm" variant="outline-dark" onClick={clearComment}>Cancel</Button>
                    <Button size="sm" variant="warning" onClick={handleCommentSubmit}>Submit</Button>
                </div>
            </Col>
        </Row>
    );

    const informationCol = (
        <Col className="col-xs-12 col-md-6 col-xl-9">
            {titleRow}
            {statisticsRow}
            {descriptionRow}
            {versionsRow}
            {exampleMapsRow}
            {commentsRow}
        </Col>
    );

    const detailContent = (
        <Row className="mt-4">
            {thumbnailCol}
            {informationCol}
        </Row>
    );
    const Info = (
        <Grid
            justifyContent='center'
            alignItems='center'
            container
            style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
            }}
        >
            <Grid item style={{ color: "red" }}>
                Target module has been hidden
            </Grid>
        </Grid>
    )
    return (
        <div className="mainContent" >
            {
                latestVersion == null || !latestVersion?.visible 
                ? Info 
                : <div className="gameInfo" role="main">
                    {detailHeader}
                    {detailContent}
                  </div>
            }
        </div>
    )
}

export default ModuleDetail